import React from "react";

type NotesProps = {
  title: string;
  text: string;
  subtext?: string;
  topCorner?: any;
};

const Notes: React.FC<NotesProps> = ({ title, text, subtext, topCorner }) => {
  return (
    <div className="bg-white relative rounded-xl shadow-sm p-4 mb-4">
      <div className="z-1 absolute top-4 right-4">{topCorner}</div>
      <div className="flex items-start gap-2">
        <div>
          <p className="font-semibold mb-3">{title}</p>
          <p className="text-sm text-gray-600">{text}</p>
          {subtext && <p className="text-sm text-gray-400 mt-2">{subtext}</p>}
        </div>
      </div>
    </div>
  );
};

export default Notes;

